'use client';

import { Button, factory, omitText, Typography } from '@kohler-dsm-library/kohler-core';
import clsx from 'clsx';
import React, { useState } from 'react';
import classes from './index.module.scss';
export const ZipCodeInputField = factory((props, ref) => {
  const {
    handleSubmit,
    onSubmit,
    id = 'zipcode-input',
    label = 'Zip Code',
    placeholder,
    CTA,
    className,
    inputValue,
    onInputChange,
    ...rest
  } = props;

  const [value, setValue] = useState(null);

  return (
    <form
      className="waitlist-form"
      onSubmit={(event) => {
        event.preventDefault();
        onSubmit?.(event);
        const target = event.target;
        handleSubmit(target.elements[0].value || '');
      }}
      onInvalid={(e) => {
        e.preventDefault();
      }}
      {...rest}
    >
      <div ref={ref} className={clsx(classes.inputContainer, 'kohler-input-field-wrapper', className)}>
        <Typography
          size="h4"
          component="input"
          id={id}
          type="text"
          className={clsx(classes.input)}
          placeholder={placeholder || label}
          ref={ref}
          aria-label={rest['aria-label']}
          autoCapitalize="off"
          autoCorrect="off"
          maxLength={75}
          min={0}
          value={inputValue ?? value ?? ''}
          onChange={(e) => {
            if (typeof onInputChange === 'function') {
              onInputChange(e);
            } else {
              const newValue = e.target.value;
              setValue(newValue.length === 0 ? null : newValue);
            }
          }}
        />
        <Button
          variant="primary"
          size="small"
          type="submit"
          disabled={!inputValue && !value}
          className={classes.inputFieldButton}
          {...omitText(CTA || {})}
        >
          {CTA?.text || 'Submit'}
        </Button>
      </div>
    </form>
  );
});